module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_5.28460031.jpg";